import { useEffect, useRef } from 'react';
import type { IMessagingAdapter } from '../adapters/messaging/IMessagingAdapter';
import { directMessageToNotification } from '../services/messaging/MessagingService';
import type { Language } from '../types';

export function useIncomingMessages(
  messagingAdapter: IMessagingAdapter | null | undefined,
  userId: string | undefined,
  lang: Language,
  push: (fields: Record<string, unknown>) => void,
) {
  const bootstrapped = useRef(false);
  const seen = useRef(new Set<string>());

  useEffect(() => {
    if (!messagingAdapter || !userId) return undefined;

    bootstrapped.current = false;
    seen.current = new Set();

    return messagingAdapter.subscribe(userId, (messages) => {
      if (!bootstrapped.current) {
        // Surface unread history (e.g. support@ mirrors received while offline).
        messages.forEach((msg) => {
          seen.current.add(msg.id);
          if (!msg.read && msg.inApp !== false) {
            push(directMessageToNotification(msg, lang));
          }
        });
        bootstrapped.current = true;
        return;
      }

      messages.forEach((msg) => {
        if (seen.current.has(msg.id)) return;
        seen.current.add(msg.id);
        push(directMessageToNotification(msg, lang));
      });
    });
  }, [messagingAdapter, userId, lang, push]);
}
